import { Component, HostListener } from "@angular/core";
import { AppService } from "../../services/app.service";
import {
  MarkerTypeId,
  IMapOptions,
  IBox,
  ILatLong,
  IMarkerIconInfo,
  MapService,
  MapTypeId
} from "angular-maps";
import {} from "node_modules/bingmaps/types/MicrosoftMaps/Microsoft.Maps.All";
import { IClusterIconInfo } from "angular-maps/src/interfaces/icluster-icon-info";

import { GenericResponseContract } from "projects/shared/models/GenericResponseContract";
import { GenericListContract } from "projects/shared/models/GenericListContract";
import { EgyptianTreasureListItemContract } from "../../models/EgyptianTreasureListItemContract";
import { MapsFiltrationContract } from "../../models/MapsFiltrationContract";

let PathData: Array<any> = null;
declare var $ :any;

@Component({
  selector: "map-root",
  templateUrl: "./map-root.component.html",
  styles: []
})
export class MapRootComponent {
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    event.target.innerWidth;
    this.refineZoomLevel()
  }

  listCount:number=0;
  mapZoomLevel=6;
  PeriodId:number;
  CitiesIds:number;
  DynastiesIds:number;
  PinInfo:any;
  input = new MapsFiltrationContract();
  _mapService:MapService;
  _markerTypeId = MarkerTypeId;
  recenterMap=false;
  _options: IMapOptions = {
    mapTypeId: MapTypeId.aerial, //removes the default points/street names...
    showCopyright: false,
    showMapTypeSelector: false, //hides map controls
    showDashboard: true, 
    disableBirdseye: true,

    //showLocateMeButton:false, //custom added
    //minZoom:3, //custom added

    // customMapStyle:{
    //   "elements": {
    //     "political": { "borderStrokeColor": "rgba(0, 0,0,0)", "borderOutlineColor": "rgba(0, 0, 0,0)" },
    //     "transportation": { "strokeColor": "rgba(0, 0,0,0)" },
    //   },
    //   "version": "1.0"
    // } //custom added after using map type aerial instead of hybred it is now obsolete
  };

_iconInfo: IMarkerIconInfo = {
  markerType: MarkerTypeId.ScaledImageMarker,
  url: '/Style Library/images/flag.png',
  scale: .08,
  markerOffsetRatio: { x: 0.15, y: 0.15 }
};

  //initially egypt boundries
  _box: IBox = {
    maxLatitude: 32.385195,
    maxLongitude: 44.468716,

    minLatitude: 19.379187,
    minLongitude: 14.695767
  };
_egyptCenter:ILatLong;


_ranges: Map<number, string> = new Map<number, string>([
    [10, "rgba(20, 180, 20, 0.5)"],
    [20, "rgba(255, 210, 40, 0.5)"],
    [Number.MAX_SAFE_INTEGER, "rgba(255, 40, 40, 0.5)"]
  ]);

  _mapPins: Array<EgyptianTreasureListItemContract> = new Array<
    EgyptianTreasureListItemContract
  >();

  constructor(private apiService: AppService) {}

  ngOnInit() {this.refineZoomLevel()}

  GetFilteredMapItems() {
    this.apiService
      .getFilteredMapItems(this.input)
      .subscribe(
        (
          response: GenericResponseContract<
            GenericListContract<EgyptianTreasureListItemContract>
          >
        ) => {
          this._mapPins = response.Data.ListItems;
          if(response && response.Data && response.Data.ListItems){
            this.listCount=response.Data.ListItems.length;
           // this._mapService.GetCenter().then(function(e){console.log(e)});

            this._egyptCenter={
              latitude:26.062350140492036,
              longitude:29.58224149999999
            }

            this._mapService.SetCenter(this._egyptCenter);
            this._mapService.SetZoom(6);
            // if(!this.recenterMap){
            //   this.recenterMap=true;
            // }else{
            //  var center=this.getLatLngCenter(response.Data.ListItems);
              // this._egyptCenter = {
              //   latitude:26.8206,
              //   longitude:30.8025
              // }
           //   this._egyptCenter = {
           //      latitude:center[0],
            //     longitude:center[1]
            //   }
              //this._mapService.SetCenter(this._egyptCenter);
              //this._mapService.SetZoom(6);
           // }

          }
          console.log(response);
        }
      );
  }

  receivePeriodId($event){
    this.PeriodId = $event;

    this.input.citiesIds=null;
    this.input.periodId=this.PeriodId;
    this.GetFilteredMapItems();
  }

  receiveCitiesIds($event){
    this.CitiesIds = $event;

    this.input.dynastiesIds=null;
    if(this.input.citiesIds==null)
      this.input.citiesIds=new Array();

    var index = this.input.citiesIds.indexOf($event);
    if (index > -1) {
      this.input.citiesIds.splice(index, 1);
    }else{
      this.input.citiesIds.push($event)
    }

    this.GetFilteredMapItems();
  }

  receiveDynastiesIds($event){
    this.DynastiesIds = $event;

    this.input.citiesIds=null;
    if(this.input.dynastiesIds==null)
      this.input.dynastiesIds=new Array();

    var index = this.input.dynastiesIds.indexOf($event);
    if (index > -1) {
      this.input.dynastiesIds.splice(index, 1);
    }else{
      this.input.dynastiesIds.push($event)
    }

    this.GetFilteredMapItems();
  }

  resetMap($event){
    this._mapPins=[];
    this.PeriodId=-1;
    this.input.periodId=null;
    this.input.citiesIds=null;
    this.input.dynastiesIds=null;
  }

  _openPopup($event){
    $("#myModal").modal()
    var sharedComponent=$('.share-wrapper.open').first().removeClass("open");

    this.PinInfo=$event;
    this.apiService.getEgyptianTreasureItemDetails($event.Id).subscribe((response:  GenericResponseContract<object>) => {
      Object.assign(this.PinInfo,response.Data);
  });
  }

  private refineZoomLevel(){
    if (window.innerWidth <= 820) {
      this.mapZoomLevel=5
    } else if (window.innerWidth <= 1024) {
      this.mapZoomLevel=6
    } else if (window.innerWidth <= 1280) {
      this.mapZoomLevel=6
    } else if (window.innerWidth <= 1366) {
      this.mapZoomLevel=6
    } else if (window.innerWidth <= 1600) {
      this.mapZoomLevel=6
    } else if (window.innerWidth < 1900) {
      this.mapZoomLevel=6
    } else if (window.innerWidth >= 1900) {
      this.mapZoomLevel=6
    }
  }

  mapService($event){
    this._mapService=$event;
  }

   rad2degr(rad) { return rad * 180 / Math.PI; }
   degr2rad(degr) { return degr * Math.PI / 180; }


   getLatLngCenter(latLngInDegr:Array<EgyptianTreasureListItemContract>) {
      var LATIDX = 0;
      var LNGIDX = 1;
      var sumX = 0;
      var sumY = 0;
      var sumZ = 0;

      for (var i=0; i<latLngInDegr.length; i++) {
          var lat = this.degr2rad(latLngInDegr[i].Latitude);
          var lng = this.degr2rad(latLngInDegr[i].Longitude);
          // sum of cartesian coordinates
          sumX += Math.cos(lat) * Math.cos(lng);
          sumY += Math.cos(lat) * Math.sin(lng);
          sumZ += Math.sin(lat);
      }

      var avgX = sumX / latLngInDegr.length;
      var avgY = sumY / latLngInDegr.length;
      var avgZ = sumZ / latLngInDegr.length;

      // convert average x, y, z coordinate to latitude and longtitude
      var lng = Math.atan2(avgY, avgX);
      var hyp = Math.sqrt(avgX * avgX + avgY * avgY);
      var lat = Math.atan2(avgZ, hyp);

      return ([this.rad2degr(lat), this.rad2degr(lng)]);
  }
}
